export type CosmeticType = 'frame' | 'badge' | 'name_color';

export interface CosmeticDef {
  id: string;
  name: string;
  type: CosmeticType;
  value: string; // CSS color, emoji, or identifier
  source: 'achievement' | 'battle_pass' | 'shop' | 'season' | 'default';
  rarity: 'common' | 'rare' | 'epic' | 'legendary';
}

export interface EquippedCosmetics {
  frame: string;
  badge: string;
  name_color: string;
}

export const DEFAULT_EQUIPPED: EquippedCosmetics = {
  frame: 'default',
  badge: 'none',
  name_color: '#c9a44c',
};

export const COSMETICS: readonly CosmeticDef[] = [
  // Frames
  { id: 'frame_default', name: 'Classic', type: 'frame', value: 'default', source: 'default', rarity: 'common' },
  { id: 'frame_gold', name: 'Golden Border', type: 'frame', value: 'gold', source: 'achievement', rarity: 'rare' },
  { id: 'frame_fire', name: 'Flame Border', type: 'frame', value: 'fire', source: 'battle_pass', rarity: 'epic' },
  { id: 'frame_crystal', name: 'Crystal Border', type: 'frame', value: 'crystal', source: 'shop', rarity: 'rare' },
  { id: 'frame_shadow', name: 'Shadow Border', type: 'frame', value: 'shadow', source: 'season', rarity: 'legendary' },
  { id: 'frame_emerald', name: 'Emerald Border', type: 'frame', value: 'emerald', source: 'shop', rarity: 'rare' },

  // Badges
  { id: 'badge_none', name: 'None', type: 'badge', value: '', source: 'default', rarity: 'common' },
  { id: 'badge_star', name: 'Star', type: 'badge', value: '⭐', source: 'achievement', rarity: 'common' },
  { id: 'badge_crown', name: 'Crown', type: 'badge', value: '👑', source: 'battle_pass', rarity: 'epic' },
  { id: 'badge_skull', name: 'Raider', type: 'badge', value: '💀', source: 'achievement', rarity: 'rare' },
  { id: 'badge_diamond', name: 'Diamond', type: 'badge', value: '💎', source: 'shop', rarity: 'rare' },
  { id: 'badge_flame', name: 'Flame', type: 'badge', value: '🔥', source: 'battle_pass', rarity: 'rare' },
  { id: 'badge_moon', name: 'Moon', type: 'badge', value: '🌙', source: 'shop', rarity: 'common' },
  { id: 'badge_trophy', name: 'Trophy', type: 'badge', value: '🏆', source: 'season', rarity: 'legendary' },

  // Name Colors
  { id: 'color_default', name: 'Gold', type: 'name_color', value: '#c9a44c', source: 'default', rarity: 'common' },
  { id: 'color_red', name: 'Crimson', type: 'name_color', value: '#e74c3c', source: 'achievement', rarity: 'rare' },
  { id: 'color_blue', name: 'Royal Blue', type: 'name_color', value: '#5b9bd5', source: 'shop', rarity: 'rare' },
  { id: 'color_green', name: 'Emerald', type: 'name_color', value: '#4a9c5e', source: 'battle_pass', rarity: 'rare' },
  { id: 'color_purple', name: 'Amethyst', type: 'name_color', value: '#a855f7', source: 'shop', rarity: 'epic' },
  { id: 'color_rainbow', name: 'Prismatic', type: 'name_color', value: 'rainbow', source: 'season', rarity: 'legendary' },
];
